import { Configuration } from "../types/customization/configuration";
import { TemplateType } from "../types/customization/template";
import { CustomMessage } from "../types/notification";

const getLabelId = (templateType: TemplateType): string => {
  if (
    templateType === "book" ||
    templateType === "calendar" ||
    templateType === "mural" ||
    templateType === "print"
  ) {
    return `kustom_MaxPageReached__${templateType}`;
  } else {
    const exhaustiveCheck: never = templateType;
    throw new Error(`Unsupported template type ${exhaustiveCheck as string}`);
  }
};

export function getMaxPageReachedMessage(
  templateType: TemplateType,
  configuration: Configuration | undefined
): CustomMessage {
  const maxPages =
    configuration && configuration.pages && configuration.pages.max ? configuration.pages.max : 0;

  let labelId;
  const parameters: {
    pageCount: number;
    [paramName: string]: string | number;
  } = {
    pageCount: maxPages,
  };
  if (
    configuration &&
    configuration.pageName &&
    configuration.pageName.plural &&
    configuration.pageName.singular
  ) {
    labelId = "kustom_MaxPageReached__generic";
    parameters.pageName =
      maxPages > 1 ? configuration.pageName.plural : configuration.pageName.singular;
  } else {
    labelId = getLabelId(templateType);
  }

  return {
    parameters,
    translationId: labelId,
  };
}
